module.exports = __webpack_public_path__ + "static/media/picture-4.4ab55f7b.jpg";